import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const MainContainer = styled(Flex).attrs({
  column: true,
  width: '100%',
})`
  color: #231f20;
  font-size: 16px;
  background: #ffffff;
  margin-top: 50px;
  overflow-x: hidden;

  @media (min-width: 992px) {
    font-size: 18px;
  }

  img {
    max-width: 100%;
  }

  @media (max-width: 767px) {
    .mobile-center {
      align-items: center;
    }
  }
`;

export const Header = styled(Flex).attrs({
  column: true,
  spacing: 30,
})`
  text-align: center;
  align-items: center;
  position: relative;

  @media (min-width: 992px) {
    text-align: left;
    align-items: flex-start;
    width: 40%;
  }
`;

export const Container = styled(Flex).attrs({
  column: true,
  width: '100%',
})`
  margin: 60px auto;
  padding: 0 30px;
  max-width: 1150px;
`;

export const FullLogo = styled.div`
  position: relative;
  max-width: 150px;
  margin: auto;

  @media (min-width: 992px) {
    display: none;
  }
`;

export const DesctopLogo = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 40%;

  @media (max-width: 991px) {
    display: none;
  }
`;

export const AppScreen = styled.div`
  margin: -10px 0 40px 0;
  transform: scale(1.5);

  @media (min-width: 768px) {
    margin: -80px 0;
    transform: none;
  }
`;

export const BioSection = styled.div`
  width: 100%;
  background: #fafafa;
  display: flex;
`;

export const BioContainer = styled(Container)`
  flex-direction: column;

  @media (max-width: 585px) {
    & > *:not(:last-child) {
      margin-bottom: 30px;
    }
  }

  @media (min-width: 586px) {
    flex-direction: row;

    & > *:not(:last-child) {
      margin-right: 30px;
    }
  }
`;

export const DarkContainer = styled(Flex).attrs({
  column: true,
  width: '100%',
})`
  color: #fff;
  padding: 30px 0;
  background-color: #231f20;
`;

export const ListItem = styled(Flex).attrs({
  spacing: 5,
})`
  i {
    margin-top: 5px;
  }
`;

export const Title = styled.h1`
  font-size: 2em;
  font-weight: bold;

  @media (min-width: 786px) {
    font-size: 3em;
  }
`;

export const FusionButton = styled.a`
  color: #fff;
  font-size: 20px;
  display: block;
  padding: 20px 35px;
  border-radius: 0;
  background: #d01b22;
  line-height: 24px;
  border-radius: 15px;
`;
